module.exports = __webpack_public_path__ + "static/media/landingBanner-tablet.dd6c7104.png";